import type RangeSlider from '@naturehouse/design-system/components/atoms/range-slider/RangeSlider';
import type { Observer } from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import type AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import BigQuery from '../../../common/BigQuery';
import SearchTrackingEvents from '../../../enums/searchTrackingEvents';
import GeoRadiusFilter from '../store/GeoRadiusFilter';
import HouseSearchFilters from '../store/HouseSearchFilters';

export default class GeoRadiusConnector implements Observer {
    readonly #filter: GeoRadiusFilter;

    readonly #element: RangeSlider;

    public constructor(element: RangeSlider, filter: GeoRadiusFilter) {
        this.#filter = filter;
        this.#element = element;

        if (!this.#element) {
            return;
        }

        this.#element.addEventListener('change', this.#handleRangeSliderChangeEvent);
    }

    public update(subject: AbstractSubject): void {
        if (!(subject instanceof GeoRadiusFilter)) {
            return;
        }

        this.#element.value = Number(subject.parameters.radius);
    }

    public static connectToElement(querySelector: string): void {
        const filters = HouseSearchFilters.getInstance();
        const element = document.querySelector(querySelector) as RangeSlider | null;
        const filter = filters.get(GeoRadiusFilter.NAME) as GeoRadiusFilter | undefined;

        if (!element || !filter) {
            return;
        }

        const connector = new GeoRadiusConnector(element, filter);
        filter.attach(connector);
    }

    readonly #handleRangeSliderChangeEvent = async (): Promise<void> => {
        const value = this.#element.value ? this.#element.value : GeoRadiusFilter.DEFAULT;
        this.#filter.radius = value;

        await BigQuery.track({
            eventName: SearchTrackingEvents.FILTER_RADIUS,
            eventParams: [{ eventKey: 'value', eventValue: value.toString() }]
        });
    };
}
